'use strict';
module.exports = require('./compile/runtime');


//////////////////
// WEBPACK FOOTER
// ./node_modules/art-template/lib/runtime.js
// module id = 3
// module chunks = 0